import { FormControl, TextField } from '@mui/material';
import React, { ChangeEvent, FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type InvoiceFilterFreeTextProps = {
    onFreeTextChange: (freeText: string) => void;
    label: string;
    initialValue: string | undefined;
};

const InvoiceFilterFreeText: FC<InvoiceFilterFreeTextProps> = ({
    onFreeTextChange,
    label,
    initialValue: defaultValue,
}: InvoiceFilterFreeTextProps) => {
    const { t: translate } = useTranslation(['invoices']);
    const [value, setValue] = useState('');

    const changeEventHandler = (event: ChangeEvent<HTMLInputElement>) => {
        onFreeTextChange(event.target.value);
        setValue(event.target.value);
    };

    useEffect(() => {
        setValue(defaultValue || '');
    }, [defaultValue]);

    return (
        <FormControl fullWidth>
            <TextField
                id="invoice-freetext-filter"
                value={value}
                label={translate(label)}
                onChange={changeEventHandler}
            />
        </FormControl>
    );
};

export default InvoiceFilterFreeText;
